import React, { useState } from 'react';
import { useUser } from '../../context/UserContext';
import RoleForm from './RoleForm';
import '../admin/AdminComponents.css';

const RolesManagement = () => {
  const { roles, deleteRole } = useUser();
  const [editingRole, setEditingRole] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const handleEdit = (role) => {
    setEditingRole(role);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this role?')) {
      try {
        await deleteRole(id);
      } catch (error) {
        alert(error.message || 'Failed to delete role');
      }
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingRole(null);
  };

  return (
    <div className="admin-section">
      <div className="admin-section-header">
        <h2 className="admin-section-title">Roles Management</h2>
        <div className="admin-section-actions">
          <button
            className="admin-button primary"
            onClick={() => {
              setEditingRole(null);
              setShowForm(true);
            }}
          >
            Add Role
          </button>
        </div>
      </div>
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Description</th>
              <th>Permissions</th>
              <th>System</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {roles.map((role) => (
              <tr key={role.id}>
                <td>{role.id}</td>
                <td>{role.name}</td>
                <td>{role.description || '-'}</td>
                <td>{role.permissions ? role.permissions.length : 0}</td>
                <td>{role.system ? 'Yes' : 'No'}</td>
                <td>
                  <div className="admin-table-actions">
                    <button
                      className="admin-icon-button"
                      onClick={() => handleEdit(role)}
                      title="Edit"
                    >
                      ✎
                    </button>
                    {!role.system && (
                      <button
                        className="admin-icon-button danger"
                        onClick={() => handleDelete(role.id)}
                        title="Delete"
                      >
                        ×
                      </button>

                    )}
                  </div>

                </td>

              </tr>

            ))}
          </tbody>

        </table>

      </div>


      {showForm && (
        <RoleForm
          role={editingRole}
          onClose={handleFormClose}
        />

      )}
    </div>

  );
};

export default RolesManagement;

